import Detail from "./Detail";

export default function InvoicesPage(props: any) {
  return (
    <div className="content_page">
      {props.action && props.action == "view" && (
        <Detail />
      )}
    </div>
  );
}
